import type { ButtonHTMLAttributes } from 'react'
import { useTranslation } from '@/i18n'

type ModalCloseButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  label?: string
}

export function ModalCloseButton({ label, className = '', ...props }: ModalCloseButtonProps) {
  const { t } = useTranslation()

  return (
    <button
      {...props}
      type="button"
      aria-label={label || t('Sluiten')}
      className={[
        'group inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#30383c] bg-[#101415] text-surface-300 transition duration-200 ease-out hover:border-accent-400/50 hover:bg-[#151a1c] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0d1113] disabled:cursor-not-allowed disabled:opacity-35',
        className,
      ].join(' ')}
    >
      <span
        aria-hidden="true"
        className="text-2xl leading-none transition-transform duration-200 ease-out group-hover:rotate-90 group-hover:scale-110 group-focus-visible:rotate-90"
      >
        ×
      </span>
    </button>
  )
}
